<template>
  <div class="solution-wrap">
    <div class="solution-banner">
      <div>
        <span>数实融合</span>
        <span>虚实互生</span>
      </div>
      <div>共同推动产业创新融合发展</div>
      <img :src="loadUrl.jjfa_bg" />
    </div>
    <div class="solution-content">
      <div>
        <div class="solution-box">
          <div class="solution-tab">
            <div v-for="(item, index) in solutionList" :key="index" :class="activeSolutionIndex == index ? 'active' : ''"
              @click="handleClickEvent(index, item)">{{ item }}</div>
          </div>
        </div>
        <VRSimulation v-if="activeSolutionIndex == 0"></VRSimulation>
        <NavigationGuide v-if="activeSolutionIndex == 1"></NavigationGuide>
        <ArWechat v-if="activeSolutionIndex == 2"></ArWechat>
        <MetaverseView v-if="activeSolutionIndex == 3"></MetaverseView>
        <VirtualMuseum v-if="activeSolutionIndex == 4"></VirtualMuseum>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, watch } from 'vue'
import MetaverseView from '@/components/mobile/MetaverseView.vue';
import VRSimulation from '@/components/mobile/VRSimulation.vue';
import NavigationGuide from '@/components/mobile/NavigationGuide.vue';
import VirtualMuseum from '@/components/mobile/VirtualMuseum.vue';
import ArWechat from '@/components/mobile/ArWechat.vue';
import router from '@/router';
import store from '@/store';
import { asynchronousRetrieval } from '@/utils'
const loadUrl: any = ref({})

const solutionList = ['VR虚拟仿真', 'AR导航导览', 'AR小程序', '元宇宙展厅', '虚拟博物馆']
const activeSolutionIndex = ref(-1)

const handleClickEvent = (index: number, item: string) => {
  store.state.programmeIndex = index
  router.push(`/solution2?type=${index}&pathName=解决方案,${item}`)
}

onMounted(async () => {
  const query: any = router.currentRoute.value.query;
  activeSolutionIndex.value = query?.type || 0

  const jjfa_bg: any = await asynchronousRetrieval('webimg/images/solution/jjfa_bg.png');
  loadUrl.value = { jjfa_bg }
})

watch(store.state, (newState) => {
  if (newState.programmeIndex != activeSolutionIndex.value) {
    activeSolutionIndex.value = newState.programmeIndex
  }
})
</script>
<style scoped lang="less">
.solution-wrap {
  background: #F7F7F7;
  min-height: calc(100vh - 400rem);

  .solution-banner {
    position: relative;
    height: 208rem;
    text-align: center;
    padding-top: 50rem;
    box-sizing: border-box;
    font-size: 24rem;
    color: #FFFFFF;

    &>img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    &>div {
      position: relative;
      z-index: 1;
    }

    &>div:first-child {
      position: relative;
      font-weight: 600;
      font-size: 48rem;
      color: #FFFFFF;
      line-height: 72rem;

      span {
        margin: 0 46rem;
      }
    }
  }

  .solution-content {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;

    .solution-box {
      width: 750rem;
      overflow: hidden;
      overflow-x: auto;

      .solution-tab {
        width: 1066rem;
        font-weight: bold;
        font-size: 24rem;
        color: #333333;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
        padding: 20rem 50rem 0;

        &>div {
          margin: 0 10rem;
          padding: 0 36rem 16rem;
          cursor: pointer;
          border-bottom: 2rem solid transparent;
          display: inline-block;
          white-space: nowrap;
        }

        .active {
          color: #2E76FF;
          border-color: #2E76FF;
        }
      }
    }
  }
}
</style>